<div class="workflow-status">
  <span class="status-icon" [ngClass]="getStatusClass(row?.status)">
    <ng-container [ngSwitch]="getStatusClass(row?.status)">

      <!-- Changes Available -->
      <span *ngSwitchCase="'changes-available'">↻</span>

      <!-- Never Published -->
      <span *ngSwitchCase="'never-published'">⚠</span>

      <!-- Published -->
      <span *ngSwitchCase="'published'">✓</span>

    </ng-container>
  </span>

  <span class="status-text">
    {{ row?.status }}
  </span>

  <span *ngIf="row?.raw?.isValid === false" class="workflow-status">
    <span class="error-icon status-icon">!</span>
    <span class="status-text">Workflow Errors</span>
  </span>
</div>
